import axios from "axios";
import config from "../config";

const DRAFT_API_BASE = `${config.NODE_API_BASE_URL_V2}/personalKycDraft`;

/**
 * Fetches the Personal KYC draft for a given user.
 */
export const getPersonalKycDraft = async (ssoUserID: string) => {
    try {
        const response = await axios.get(`${DRAFT_API_BASE}/${ssoUserID}`);
        // Return full draft object to allow status checks
        return response.data?.data; 
    } catch (error) {
        console.error("Error fetching personal kyc draft:", error);
        return null;
    }
};

/**
 * Updates a specific step in the Personal KYC draft.
 * @param ssoUserID The user's SSO ID
 * @param stepKey The key for the step (e.g., 'identity', 'questionnaire')
 * @param data The data to merge/save
 */
export const updatePersonalKycDraftStep = async (ssoUserID: string, stepKey: string, data: any) => {
    try {
        const response = await axios.put(`${DRAFT_API_BASE}/${ssoUserID}`, {
            stepKey,
            data
        });
        return response.data?.data;
    } catch (error) {
        console.error(`Error updating personal kyc draft step ${stepKey}:`, error);
        return null;
    }
};

/**
 * Submits the full Personal KYC draft to permanent storage.
 */
export const submitPersonalKycDraft = async (ssoUserID: string) => {
    try {
        const response = await axios.post(`${DRAFT_API_BASE}/submit/${ssoUserID}`);
        return response.data;
    } catch (error) {
        console.error("Error submitting personal kyc draft:", error);
        return { status: 0, msg: "Submission failed" };
    }
};

/**
 * Resets the Personal KYC draft to its initial state.
 */
export const resetPersonalKycDraft = async (ssoUserID: string) => {
    try {
        const response = await axios.put(`${DRAFT_API_BASE}/reset/${ssoUserID}`);
        return response.data?.data;
    } catch (error) {
        console.error("Error resetting personal kyc draft:", error);
        return null;
    }
};
